module.exports = __webpack_public_path__ + "static/media/logo_bw.d72ab7e3.svg";